module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-404",
    attrs: {
      "id": "scene"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/404/logo.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "layer feidie",
    attrs: {
      "src": require("../../assets/404/feidie.png"),
      "data-depth": "0.30"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img404",
    attrs: {
      "src": require("../../assets/404/img-404.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3541f943","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nvui/error/404.vue
// module id = 145
// module chunks = 1